'use strict';

// Mobile apps controller
angular.module('mobile-apps').controller('MobileAppsController', [
  '$rootScope',
  '$scope',
  '$stateParams',
  '$location',
  'Authentication',
  'MobileApps',
  'AvailableLanguages',
  'EntryCount',
  'Teams',
  'TranslationImport',
  'UserTeamMembers',
  'MobileAppIntegrations',
  'SubscriptionMain',
  'Mau',
  'TranslationOrder',
  'Languages',
  '$state',
  '$modal',
  '$timeout',
  '$window',
  'SweetAlert',
  'TranslationMemory',
  'EventTracker',
  'Groups',
  'Utilities',
  'AppstoreIntegration',
  'XtmIntegration',
  'ConfigData',
  'EntryMain',
  'TagMain',
  'JiraApi',
  'DEFAULT_TAG_CATEGORIES',
  function (
    $rootScope,
    $scope,
    $stateParams,
    $location,
    Authentication,
    MobileApps,
    AvailableLanguages,
    EntryCount,
    Teams,
    TranslationImport,
    UserTeamMembers,
    MobileAppIntegrations,
    SubscriptionMain,
    Mau,
    TranslationOrder,
    Languages,
    $state,
    $modal,
    $timeout,
    $window,
    SweetAlert,
    TranslationMemory,
    EventTracker,
    Groups,
    Utilities,
    AppstoreIntegration,
    XtmIntegration,
    ConfigData,
    EntryMain,
    TagMain,
    JiraApi,
    DEFAULT_TAG_CATEGORIES
    ) {
    $scope.entryCountMap = {};
    $scope.authentication = Authentication;
    $scope.mobileAppId = $stateParams.mobileAppId;

    //Preload the team owner name here
    $scope.checkbox = '';
    $scope.createTeam = true;
    $scope.baseLanguage = 'en';
    $scope.noAppCreated = false;
    $scope.languages = [];
    $scope.tagCategories = [];
    $scope.tags = {};
    $scope.teams = [];

    $scope.isAdmin = false;
		if ($scope.authentication.user.username === 'superadmin' && $scope.authentication.user.email === 'superadmin@applanga.com') {
      $scope.isAdmin = true;
      
      Teams.getAll(function (teams) {
        $scope.teams = teams;
      });
		}

    if(angular.equals($scope.tags, {}) && $scope.mobileAppId){
      TagMain.loadTags($scope.mobileAppId, true, function (err, result) {
        if (err) {
          return;
        }
        $scope.tags = TagMain.tags;
      });
    }
    
    $scope.initPrepareView = function() {
      $scope.openTutorial = false;
      $scope.loadedStatus = true;

      $scope.appId = $stateParams.mobileAppId;

      $scope.groupsIncluded = [];
      $scope.groupCount = {};

      async.parallel(
          {
            groups : $scope.fetchGroups,
            mobileApp : $scope.fetchMobileApp,
            defaultGroup: $scope.fetchDefaultGroup
          },
          function(err, result)
          {
            if(err)
            {
              return;
            }
            $scope.mobileApp = result.mobileApp;
            $scope.groups = result.groups;
            $scope.defaultGroupName= result.defaultGroup.name;
            
            $scope.groups.forEach(function(group)
            {
              if(group.name === $scope.defaultGroupName || group.include === true)
              {
                $scope.includeGroup(group._id);
              }
              $scope.groupCount[group._id] = $scope.group = EntryCount.getCountforGroups({
                mobileAppId: $stateParams.mobileAppId,
                groupId: group._id});
            });

          });

    };


    $scope.toggleTutorial = function() {
      //crappy 'hack' to trigger the watch function of turotial directive
      if($scope.openTutorial === 2)
      {
        $scope.openTutorial = 1;
      }else
      {
        $scope.openTutorial = 2;
      }
    };

    $scope.initCreateView = function() {
      $scope.availableLanguages = AvailableLanguages.get();

		$scope.getOwnerFromTeam(null, function(err, teams) {
			if ($rootScope.isWhiteLabelSettingActive('uploadOnProjectCreate') === true) {
				// Sites which display file upload directly after project create
				// do not allow different teams so we automatically choose the
				// first one (which should be the only one that exits).
				$scope.createTeam = false;
				$scope.teamId = teams[0]._id;
			}
		});

    };

    $scope.initDetailView = function() {
      $scope.currentUserSubscription = {};

      // Check if there is an error message in query-parameter to display
      var queryParameters = $location.search();
      if (queryParameters.hasOwnProperty('error-message')) {
        Utilities.showMessage(
          'Error!',
          decodeURI(queryParameters['error-message']),
          'error'
        );
      }
      // Only used in translation memory and allows to make only changes
      // when it is empty
      $scope.changesAllowed = false;


      $scope.appId = $stateParams.mobileAppId;
      $scope.loadedStatus = false;
      $scope.tagsInputDefaults = {placeholder:''};

      $scope.getAppSubscription($scope.appId);

      // Shows the actual saved state of the application. That if they activate
      // groups the only state that changes is groups and not anything else
      // they also had changed.
      $scope.oldmobileAppData = {
		  name: '',
		  baseLanguage: undefined,
		  team: undefined,
		  draftModeEnabled: false,
		  collectMissingEnabled: false,
		  groupsEnabled: false,
	  };

      async.parallel(
          {
            languages: $scope.fetchInAppLanguages,
            availableLanguages: $scope.fetchAvailableLanguages,
            mobileApp : function(asyncCB) {
				EntryMain.loadMobileApp($scope.appId, true, asyncCB);
			},
            mobileApps : $scope._fetchMobileApps
          },
      function(err, result)
      {
        $scope.loadedStatus = true;

        if(err)
        {
          return;
        }
        $scope.availableLanguages = result.availableLanguages;
        $scope.mobileApp = result.mobileApp;

        if (!$scope.mobileApp._xtmCustomer) {
          $scope.mobileApp._xtmCustomer = {};
        }

        if ($scope.mobileApp.type === 'tm') {
			// Only allow to make changes to the translation memory settings
			// when it is totally empty
			EntryCount.getCountForApps({mobileAppId:$scope.mobileApp._id}, function(data) {
				if (data.all === 0) {
					$scope.changesAllowed = true;
				}
			});
		}

		$scope.oldmobileAppData = {
		  name: $scope.mobileApp.name,
		  baseLanguage: $scope.mobileApp.baseLanguage,
		  team: $scope.mobileApp.team,
		  draftModeEnabled: $scope.mobileApp.draftModeEnabled,
		  collectMissingEnabled: $scope.mobileApp.collectMissingEnabled,
		  groupsEnabled: $scope.mobileApp.groupsEnabled
		};

        $scope.mobileApps = result.mobileApps;
        $scope.languages = result.languages;
        $scope.syncApp = ($scope.mobileApps[0]._id === $scope.mobileApp._id)?$scope.mobileApps[1]:$scope.mobileApps[0];

        $scope.makeTokenAppSecret($scope.mobileApp.apiSecret, $scope.mobileApp._id);
        $scope.draftKey = $scope.mobileApp.apiSecret.slice(0,4);
        $scope.getOwnerFromTeam($scope.mobileApp.team._id);
    });
    
      TagMain.loadTagCategories($scope.appId, true, function (err, result) {
        $scope.tagCategories = angular.copy(DEFAULT_TAG_CATEGORIES);
        if (!jQuery.isEmptyObject(TagMain.tagCategories)) {
          Object.keys(TagMain.tagCategories).forEach(function(tagCategory){
            if(!$scope.tagCategories.some(function(item){ return item.name === tagCategory.name; })){
              $scope.tagCategories.push(TagMain.tagCategories[tagCategory]);
            }
          });
        }
      });
    };


	/**
	 * Returns if the given integration is active for the app
	 */
    $scope.hasIntegration = function(integrationName) {
    	if (!$scope.mobileApp || !$scope.mobileApp.integrations) {
    		return false;
		}

    	return $scope.mobileApp.integrations.hasOwnProperty(integrationName);
	};


	/**
	* Returns the data of integration if it exists
	*/
	$scope.getIntegration = function(integrationName) {
	  if (!$scope.mobileApp ||
		  !$scope.mobileApp.integrations ||
		  !$scope.mobileApp.integrations.hasOwnProperty(integrationName) ||
		  $scope.mobileApp.integrations[integrationName].length === 0) {
		  return undefined;
	  }

	  return $scope.mobileApp.integrations[integrationName][0];
	};


	/**
	 * Displays modal which user has to confirm to remove integration
	 */
    $scope.openRemoveIntegrationModal = function(integrationKey, integrationName) {
		SweetAlert.swal(
			{
				title             : 'Are you sure?',
				text              : 'This will delete the Integration with "' + integrationName + '".',
				type              : 'warning',
				showCancelButton  : true,
				confirmButtonColor: '#DD6B55',
				confirmButtonText : 'Yes, delete it!',
				cancelButtonText  : 'No, cancel!',
				closeOnConfirm    : true,
				closeOnCancel     : true
			},
			function (isConfirm) {
				if (isConfirm) {
					$scope.deleteIntegration($scope.mobileApp._id, integrationKey, function (err, result) {
						if (err) {
							console.log(err);
							Utilities.showMessage(
								'Error!',
								'There was a problem deleting the integration. Please contact the support! Thanks!',
								'error'
							);
							return;
						}

						// Load the new data
						$scope.fetchMobileApp(function(err, mobileApp) {
							$scope.mobileApp = mobileApp;
						});

						Utilities.showMessage(
							'Success!',
							'The integration got removed!',
							'success'
						);
					});
				}
			}
		);
	};


	/**
	 * Deletes the integration with the given key from app
	 */
    $scope.deleteIntegration = function(appId, integrationKey, callback) {
		MobileAppIntegrations.remove({ mobileAppId: appId, key :integrationKey },
			function success(response) {
				return callback(null, response);
			}, function failure(errResponse) {
				return callback(errResponse);
			}
		);
	};

    /**
     * check if there are some keys belong to some groups (not main group)
     *
     */
    $scope.checkKeysInGroups = function() {
        if($scope.mobileApp.groupsEnabled) return;

        var defaultGroupId = EntryMain.defaultGroup._id;
        var nonDefaultGroupIds = [];
        Object.keys(EntryMain.groups).forEach(function(groupId) {
            if(groupId !== defaultGroupId) {
                nonDefaultGroupIds.push(groupId);
            }
        });

        var checkKeys = false;

        async.each(nonDefaultGroupIds, function(groupId, loopCb) {
            EntryCount.getCountforGroups({ mobileAppId:$scope.mobileApp._id, groupId: groupId }, function(data) {
                if(data.current) {
                    checkKeys = true;
                }
                loopCb();
            });
        }, function (err) {
            if(err) {
                Utilities.showMessageErrorResponse(err);
            }

            if(checkKeys) {
                $scope.mobileApp.groupsEnabled = true;
                Utilities.showMessage(
                    'Warning!',
                    'Groups can only be disabled if all there are no strings in any group other then the main group',
                    'warning'
                );
            }
        });
    };


	/**
	 * Saves the group setting and redirects to the
	 */
	$scope.editGroups = function() {

		if (!$scope.mobileApp.groupsEnabled) {
			return;
		}

		if ($scope.oldmobileAppData.groupsEnabled) {
			// If groups were already enabled go directly to group page
			$state.go('listGroups', {mobileAppId: $scope.mobileAppId});
			return;
		}

		// If groups were not enabled before save the app first with
		// groups enabled and then redirect to group page
		var mobileApp = $scope.mobileApp;

		Object.keys($scope.oldmobileAppData).forEach(function(key) {
			if (key === 'groupsEnabled') {
				// Skip reverting groupsEnabled because that is the value we
				// actually want to change
				return;
			}
			mobileApp[key] = $scope.oldmobileAppData[key];
		});

		mobileApp.$update(function () {
			// Force refresh of the cached app Data
			EntryMain.loadMobileApp(mobileApp._id, true, function() {});
			$state.go('listGroups', {mobileAppId: $scope.mobileAppId});
		}, function (errorResponse) {
			$timeout(function() {
				SweetAlert.swal(
					{
						title: 'Problem!',
						text : 'There was a problem!\nPlease try again later or inform support.\n\nThanks!',
						type : 'error'
					}
				);
			}, 50);
		});
	};


    $scope.requestSettings = function()
    {
      $scope.loadedStatus = false;
      var groupsIncluded = _.filter($scope.groups, { included : true });
      //console.log(groupsIncluded);
      MobileApps.requestSettings({
        mobileAppId: $stateParams.mobileAppId,
        groups: JSON.stringify(groupsIncluded)
      }, function (response) {
        $scope.loadedStatus = true;
        if(!response.settings)
        {
          return;
        }
        //console.log('path returned : '+response.settings);
        window.location.assign(response.settings);
      }, function (errorResponse) {
        $scope.loadedStatus = true;
        $scope.error = errorResponse.data.message;
      });
    };

    $scope.includeGroup = function(groupId)
    {
      if(!groupId) return;
      var group = _.find($scope.groups, { _id : groupId});
      group.included =  true;

    };

    $scope.excludeGroup = function(groupId)
    {
      if(!groupId) return;

      var group = _.find($scope.groups, { _id : groupId});
      if(group.name === $scope.defaultGroupName)
      {
        return;
      }
      group.included =  false;

    };

    $scope.getValidTeams = function () {
      if (!$scope.teams || !$scope.teams.length) {
        return [];
      }

      return $scope.teams.filter(team => $scope.isAdmin && team.memberRole !== 'owner' || !$scope.isAdmin && team.memberRole === 'owner').sort((a, b) => a.name > b.name ? 1 : -1);
    };

    $scope.trimString = function(text, maxLength)
    {
      if(typeof text === 'undefined' || text === null) return '';
      if(typeof maxLength === 'undefined')
      {
        maxLength =36;
      }
      var result = text;
      var dots = '...';
      if(text.length > maxLength)
      {
        result = text.slice(0,maxLength - 1 - dots.length) + dots;
      }
      return result;
    };

    $scope.fetchDefaultGroup = function(callback)
    {
      Groups.defaultGroup(
          {
            mobileAppId: $stateParams.mobileAppId
          },
          function success (response) {
            callback(null, response);
          }, function failure (errResponse) {
            callback(errResponse);
          });
    };

    $scope.fetchGroups = function (callback) {
      Groups.list(
          {
            mobileAppId: $stateParams.mobileAppId
          },
          function success (response) {
            callback(null, response);
          }, function failure (errResponse) {
            callback(errResponse);
          });
    };

    $scope.fetchAvailableLanguages = function (callback) {

      AvailableLanguages.get(function success (response) {
        callback(null, response);
      }, function failure(errorResponse) {
        callback(errorResponse);
      });

    };
    $scope.fetchMobileApp = function (callback) {
      MobileApps.get({
        mobileAppId: $stateParams.mobileAppId
      }, function (response) {
        return callback(null, response);
      }, function (errResponse) {
        return callback(errResponse);
      });
    };

    $scope.fetchInAppLanguages = function (callback) {
      Languages.query(
          {
            mobileAppId: $stateParams.mobileAppId
          },
          function success (response) {
            callback(null, response);
          }, function failure (errResponse) {
            callback(errResponse);
          });
    };

    /**
     * Sorts entries depending on rights and all with the same rights according
     * to name
     */
    $scope.rightSort = function(entry) {
		var sortValue = '';
		if (entry.roleInApp === 'admin') {
			sortValue = '4';
		} else if (entry.roleInApp === 'manager') {
			sortValue = '3';
		} else if (entry.roleInApp === 'translator') {
			sortValue = '2';
		} else {
			sortValue = '1';
		}

		return sortValue + entry.created;
    };


	// Creates Translation Memory for current team
	$scope.createTranslationMemory = function(teamId) {

	  if (!teamId) {
	    teamId = $stateParams.teamId;
	  }

	  TranslationMemory.create({
		  teamId: teamId
	  }, function(translationMemory) {

		  // Track the TM creation
		  var eventData = {
		  	team_id: teamId
		  };
		  EventTracker.track('TM Create Success', 'TM Create', eventData);

		  // Force refresh of the cached app Data
		  EntryMain.loadMobileAppsTeam(teamId, true, function() {});
		  $scope.mobileApp.team.translationMemory = translationMemory;
	  }, function(error) {
		  $timeout(function() {
			  SweetAlert.swal(
				  {
					  title: 'Problem!',
					  text : 'There was a problem!\nPlease try again later or inform support.\n\nThanks!',
					  type : 'error'
				  }
			  );
		  }, 50);
	  });
	};


	$scope.updateSubscription = function() {
		if ($scope.currentUserSubscription.billingId) {
			// Redirect to subscription page
			$state.go('editSubscription', {billingId: $scope.currentUserSubscription.billingId});
		} else {
			// Redirect to billing form
			$state.go('listBillings');
		}
	};



	  /**
	   * Updates the current usersubscription information
	   */
	  $scope.getUserSubscription = function(forceRefresh) {
		  SubscriptionMain.getUserPlan(forceRefresh, function(err, currentUserSubscription) {
			  if (err) {
				  $scope.currentUserSubscription = {};
				  return;
			  }
			  $scope.currentUserSubscription = currentUserSubscription;
		  });
	  };

    /**
	 * Updates the current subscription information
	 */
	  $scope.getAppSubscription = function(mobileAppId, forceRefresh) {
		  SubscriptionMain.getAppPlan(mobileAppId, forceRefresh, function(err, currentAppSubscription) {
			  if (err) {
				  $scope.currentAppSubscription = {};
				  return;
			  }
			  $scope.currentAppSubscription = currentAppSubscription;
		  });
    };
    
    /** 
     *`Getting team members count excluding TPT user role
    */
		$scope.getMembersCount = function(){
			if(!$scope.userTeamMembers){
				return 0;
			}
			
			var members = $scope.userTeamMembers.filter(function(m){ return m.role && !m.role.toLowerCase().includes('tpt'); });

			if(members){
				return members.length;
			} else {
				return 0;
			}
		};

    $scope.appsListsType = {
      myMobileApps: 'myMobileApps',
      sharedApps: 'sharedApps'
    };
    $scope.appsListPagesConfig = {
      myMobileApps: {
        current: 1,
        size: 20,
        total: 0
      },
      sharedApps: {
        current: 1,
        size: 20,
        total: 0
      }
    };
    
    $scope.getMobileAppsByPage = function () {
      $scope._fetchMobileAppsByPage($scope.appsListPagesConfig, function (err, response) {
        if (err) {
          return;
        }

        $scope.loadedStatus = true;
        if (response.mobileApps.length === 0) {
          $scope.noAppCreated = true;
          $state.go('createMobileApp');
          return;
        }
        
        $scope.myMobileApps = response.mobileApps || [];
        $scope.sharedMobileApps = response.sharedApps || [];
        $scope.mobileApps = $scope.myMobileApps.concat($scope.sharedMobileApps) || [];

        $scope.appsListPagesConfig.myMobileApps.total = response.mobileAppsCount;
        $scope.appsListPagesConfig.sharedApps.total = response.sharedAppsCount;

        $scope.mobileApps.forEach(function (app) {
          $scope.entryCountMap[app._id] = EntryCount.getCountForApps({ mobileAppId: app._id });

          // Add the role of the current users on the app
          app.roleInApp = 'none';
          if(app.team && app.team.members) {
            for (var i = 0; i < app.team.members.length; i++) {
              if (Authentication.user._id === app.team.members[i].user) {
                app.roleInApp = app.team.members[i].role;
                break;
              }
            }
          }
          //calculateStatisticsForApp(app);
        });

        if ($rootScope.isWhiteLabelSettingActive('listProjectsTogether') === true) {
          $scope.myMobileApps = $scope.mobileApps;
        } 
      });
    };

    $scope.initListView = function() {
      $scope.currentUserSubscription = {};
      $scope.getUserSubscription();
      $scope.availableLanguages = AvailableLanguages.get();
      $scope.userTeamMembers = UserTeamMembers.get();
      $scope.mau = Mau.get({});
      $scope.getMobileAppsByPage();
    };

    $scope.getProjectsPages = function(appsListType, total){
      var pages = [];
      var page = 1;
      var pageCounter = 1;
      var pageSize = $scope.appsListPagesConfig[appsListType].size;
      for (var index = 1; index <= total; index++) {
        if(pageCounter === pageSize || (index === total && (index !== pages.length * pageSize))){
          pages.push(page++);
          pageCounter = 1;
        }
        pageCounter++;
      }

      return pages;
    };

    $scope.disablePrevButton = function(appsListType){
      return $scope.appsListPagesConfig[appsListType].current === 1;
    };

    $scope.disableNextButton = function(appsListType){
      return $scope.getProjectsPages(appsListType, $scope.appsListPagesConfig[appsListType].total).length === $scope.appsListPagesConfig[appsListType].current;
    };

    $scope.goToProjectsPage = function(appsListType, page){
      $scope.appsListPagesConfig[appsListType].current = page;
      $('html,body').animate({
        scrollTop: $('#' + appsListType).offset().top - $('header').height()}, 'fast');
      $scope.getMobileAppsByPage();
    };

	/**
	 * Returns if the current plan of the app includes a glossary
	 */
    $scope.planIncludesGlossary = function() {
		if ($scope.currentAppSubscription && $scope.currentAppSubscription.glossary === true) {
			return true;
		}
		return false;
	};


    $scope.enableDefaultTeam = function () {
      $scope.createTeam = true;
      $scope.teamOwner = Authentication.user.displayName;
    };

    $scope.enableChooseTeam = function () {
      $scope.createTeam = false;
      $scope.teamOwner = '';
    };

    // Create new Mobile app
    $scope.create = function () {
      var mobileAppData = {
        name          : $scope.name,
        baseLanguage  : $scope.baseLanguage,
        createTeam    : $scope.createTeam
      };

      if ($scope.createTeam === false) {
        mobileAppData.teamId = $scope.teamId;
      }

      // Create new Mobile app object
      var mobileApp = new MobileApps(mobileAppData);

      // Redirect after save
      mobileApp.$save(function (response) {

        // Track the app creation
        var eventData = {
          app_id: response._id
        };
        EventTracker.track('App Create Success', 'App Create', eventData);

        // Clear form fields
        $scope.name = '';
        $scope.noAppCreated = false;

        $rootScope.$broadcast('intercom_event',{
          eventName :'created-mobile-app',
          data : {
            appName : mobileAppData.name,
            appId : response._id,
            baseLanguage : mobileAppData.baseLanguage
          }
        });

		// if (Authentication.user.lsp) {
		if ($rootScope.isWhiteLabelSettingActive('uploadOnProjectCreate') === true) {
		  // Is a LSP user so redirect to file upload page
		  $location.path('orders/app/' + response._id + '/translation-order-upload');
		} else {
		  // Is a regular user so redirect to onboarding page
		  $location.path('projects/' + response._id + '/onboarding');
		}

      }, function (errorResponse) {
      	$scope.error = errorResponse.data.message;

      	if (errorResponse.data.upgradeRequired === true) {

			// Displays upgrade subscription modal depending on the given team-owner
      		var showUpgradeSubscription = function(teamOwner) {
				Utilities.upgradeSubscriptionTeam('apps', teamOwner, Authentication.user, mobileAppData.teamId, function(err, result) {
					// Utilities.upgradeSubscriptionModal('apps', function(err, result) {
					if (err && err !== 'escape key press') {
						Utilities.showMessage(
							'Error!',
							'There was a problem updating your subscription. Please contact the support! Thanks!',
							'error'
						);
						return;
					}

					if (result === true) {
						$scope.error = undefined;
						$scope.getUserSubscription(true);
					}
				});
			};

			if (!$scope.createTeam) {
				// Get the team owner to see if the current user is the team owner
				$scope.getOwnerFromTeam(mobileAppData.teamId, function(err, teamOwner) {
					showUpgradeSubscription(teamOwner);
				});
			} else {
				// New team gets created so current user will be team owner
				showUpgradeSubscription(Authentication.user);
			}
		}
      });

    };

    $scope.getOwnerFromTeam = function (teamId, callback) {
      if($scope.isAdmin){
        if (teamId) {
          let team = $scope.teams.find((item) => item._id === teamId);
          if(team){
            $scope.teamOwner = team.user.displayName;
          }
        } else {
          if (callback) {
            callback(null, $scope.teams);
          }
        }
      } else {
        $scope.teams = Teams.query(function() {
          if (teamId) {
            for (var i in $scope.teams) {
              var team = $scope.teams[i];
              if (team._id === teamId) {
                $scope.teamOwner = team.user.displayName;
                if (callback) {
                  callback(null, team.user);
                }
              }
            }
          } else {
            if (callback) {
              callback(null, $scope.teams);
            }
          }
        });
      }
    };

    $scope.getCorrespondingTeamOwner = function(team){
      if($scope.isAdmin){
        $scope.teamOwner = team.user.displayName;
      }
    };

    // Remove existing Mobile app
    $scope.remove = function (cb) {
      var mobileAppCopy = angular.copy($scope.mobileApp);

      $scope.mobileApp.$remove(function () {
        if (mobileAppCopy.type === 'tm') {
          // If translation memory gets deleted we have to update all the apps
          // which use it.
          EntryMain.loadMobileAppsTeam(mobileAppCopy.team._id, true, function(error, result) {});
        }

        if (angular.isFunction(cb)) {
          cb();
        }
      }, function(err) {
      	Utilities.showMessageErrorResponse(err);
	  });
    };

    // Update existing Mobile app
    $scope.update = function () {
      var mobileApp = $scope.mobileApp;

      mobileApp.$update(function () {
        $location.path('projects/' + mobileApp._id);
        // Force refresh of the cached app Data
        EntryMain.loadMobileApp(mobileApp._id, true, function() {});
      }, function (errorResponse) {
        $scope.error = errorResponse.data.message;
      });

      if($scope.removingTagCategories.length){
        TagMain.removeTagCategories($scope.removingTagCategories, function(err, result){ 
          if (err && err.data) {
            $timeout(function() {
              SweetAlert.swal(
                {
                  title: 'Oops!',
                  text: err.data.message,
                  type: 'error',
                  showCancelButton: false
                }
              );
            }, 50);
            return;
          }
         });
      }

      if($scope.newTagCategories.length){
        TagMain.createTagCategories($scope.newTagCategories);
      }
    };

    $scope._fetchMobileApps = function(callback) {
      MobileApps.query(function (response) {
        callback(null, response);
      }, callback);
    };

    $scope._fetchMobileAppsByPage = function(page, callback) {
      MobileApps.queryByPage(page, function (response) {
        callback(null, response);
      }, callback);
    };

    $scope.copyToClipboard = function(textToCopy, callback){
      var copyTextArea = document.createElement('textarea');
      copyTextArea.value = textToCopy;
      document.body.appendChild(copyTextArea);

      copyTextArea.select();

      try {
        var successful = document.execCommand('copy');
        var msg = 'Copied!';
        if(!successful){
          msg = 'Whoops, not copied!';
        }
        $scope.clipboardText = msg;
        $timeout(function(){
          $scope.clipboardText = 'Copy to Clipboard';
        }, 550);
      } catch (err) {
        console.log('Oops, unable to copy');
      }
      
      document.body.removeChild(copyTextArea);

      if(callback){
        callback();
      }
    };

    $scope.getAccessToken = function() {
      MobileApps.getToken({mobileAppId:$scope.mobileApp._id},function (response) {
        if(response.hasOwnProperty('accessToken'))
        {
          $scope.clipboardText = 'Copy to Clipboard';
          var tokenTitle = 'API Token';
          var tokenText = `
          Your API access token: 
          <div class="input-group" style="margin-top: 10px">
            <input id="txtApiToken" type="text" class="form-control" autocomplete="off" readonly="readonly" 
                  style="font-weight: bold;font-size:12px;margin:0" 
                  value="${response.accessToken}">
            <span id="btnCopyClipboard" class="input-group-addon copy-to-clipboard-settings" title="Copy to Clipboard"><i class="far fa-clipboard"></i></span>
          </div>`;
                          
          SweetAlert.swal(
              {
                title: tokenTitle,
                text : tokenText,
                html : true,
                type : 'success',
                width : 640,
              }
          );
          $timeout(function(){
            $('#btnCopyClipboard').click(function(){
              $scope.copyToClipboard(response.accessToken, function(){
                $('#txtApiToken').select();
                $('.sweet-alert h2').html('Token copied to clipboard!');
                $timeout(function(){
                  $('.sweet-alert h2').html(tokenTitle);
                }, 950);
              });
            });
          }, 150);
        }else
        {
          SweetAlert.swal(
              {
                title: 'Applanga API',
                text : 'API level access is only available starting from PRO tier and will be enabled on request. If you are interested, please reach out to us <a href="mailto:info@applanga.com?subject=Applanga+API+Access">via mail</a> or through the chat functionality.',
                html : true,
                type : 'info'
              }
          );
        }
      }, function (errorResponse) {
        $scope.error = errorResponse.data.message;
      });
    };

    $scope.openSyncAppModal = function (app) {
      SweetAlert.swal(
          {
            title             : 'Are you sure?',
            text              : 'This will delete all App data and replace it with data from app "' + app.name + '" and can not be reversed.',
            type              : 'warning',
            showCancelButton  : true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText : 'Yes, sync now!',
            cancelButtonText  : 'No, cancel!',
            closeOnConfirm    : true,
            closeOnCancel     : true
          },
          function (isConfirm) {
            if (isConfirm) {

              $scope.loadedStatus = false;
              MobileApps.syncApp(
                  {
                    mobileAppId : $scope.mobileApp._id,
                    syncAppId : app._id
                  },
                  {},
                  function success (response) {
                    $scope.loadedStatus = true;
                    $scope.mobileApp = response;

                    // Force refresh of the cached app Data
                    EntryMain.loadMobileApp($scope.mobileApp._id, true, function() {
                      $scope.languages = EntryMain.languages;
                    });

                   // console.log($scope.mobileApp);
                    SweetAlert.swal(
                        {
                          title: 'Success',
                          text : 'App Data has been synced!',
                          type : 'success'
                        }
                    );
                  }, function failure (errorResponse) {
                    $scope.loadedStatus = true;
                    $scope.error = errorResponse.data.message;
                  });
            }
          }
      );
    };

    $scope.openDeleteAppModal = function () {
      // The app data will not be available anymore after the delete so we
      // query it first
      var enrichPromise = EventTracker.enrichEventData({
        app_id: $scope.mobileApp._id
      });
      var mobileAppCopy = angular.copy($scope.mobileApp);

      SweetAlert.swal(
        {
          title             : 'Are you sure?',
          text              : 'This will delete the App "' + $scope.mobileApp.name + '" forever and can not be recovered.',
          type              : 'warning',
          showCancelButton  : true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText : 'Yes, delete it!',
          cancelButtonText  : 'No, cancel!',
          closeOnConfirm    : true,
          closeOnCancel     : true
        },
        function (isConfirm) {
          if (isConfirm) {
            $scope.remove(function () {

              // Once the data is available and the app got removed track the event
              enrichPromise.then(
                function(eventData) {
                  // Track the delete
                  if (mobileAppCopy.type === 'tm') {
                    EventTracker.track('TM Delete Success', 'TM Delete', eventData);
                  } else {
                    EventTracker.track('App Delete Success', 'App Delete', eventData);
				  }

                }
              );

              $state.go('listMobileApps');
            });
          }
        }
      );
    };

    $scope.notifyTokenCopied = function () {
      SweetAlert.swal(
        {
          title: 'Success',
          text : 'App Token has been copied to memory!',
          type : 'success'
        }
      );
    };

    $scope.makeTokenAppSecret = function (apiSecret, mobileAppId) {
      $scope.tokenSecret = apiSecret + '+' + mobileAppId;
    };

    /**
     * Go to team page of current app
     */
    $scope.goToTeamPage = function() {
      $state.go('viewTeam', {teamId: $scope.mobileApp.team._id});
    };


    /**
    * Go to teams page of current user
    */
    $scope.goToTeamsPage = function() {
      $state.go('listTeams');
    };

	  /**
	   * Imports translations into base language
	   */
	  $scope.importFiles = function() {
      var baseLanguage = EntryMain.mobileApps[$scope.mobileApp._id]._baseLanguage;
      
      if(angular.equals($scope.tags, {})){
        $scope.tags = TagMain.tags;
      }
      
      var importer = new TranslationImport($scope.mobileApp, EntryMain.defaultGroup, baseLanguage, $scope.tags, $scope.tagCategories);
      importer.selectFile()
        .then(function(data) {
          $window.location.reload();
        })
        .catch(function(err) {
          Utilities.showMessage('Error', err, 'error');
        });
	  };


	  /**
	   * Opens modal which allows to export as xliff, spreadsheet or multi
	   * language spreadsheet
	   */
	  $scope.exportTranslations = function() {
		  var modalInstance = $modal.open({
			  templateUrl: 'modules/mobile-apps/views/export-translations-modal.client.view.html',
			  controller: 'ExportTranslationsModalController',
			  backdrop: true,
			  size: 'md',
			  resolve: {
				  ModalData: function() {
					  return {
						  mobileApp: $scope.mobileApp,
						  entries: [],
						  groupId: undefined
					  };
				  }
			  }
		  }).result.catch(function(error) {
        if (!(error === 'cancel' || error === 'escape key press' || error === undefined)) {
          throw error;
        }
      });
	  };


	  /**
	   * Returns if the current plan of the app includes the xtm integration
	   */
	  $scope.planIncludesXtmIntegration = function() {
		  if ($scope.currentAppSubscription && $scope.currentAppSubscription.xtmIntegration === true) {
			  return true;
		  }
		  return false;
	  };


	  /**
	   * Returns if the current plan of the app includes the appstore integration
	   */
	  $scope.planIncludesAppstoreIntegration = function() {
		  if ($scope.currentAppSubscription && $scope.currentAppSubscription.appstoreIntegration === true) {
			  return true;
		  }
		  return false;
	  };


	  /**
	   * Opens a modal which allows to connect to Apple Ios Appstore
	   */
	  $scope.connectIosStore = function() {
		  var modalInstance = $modal.open({
			  templateUrl: 'modules/mobile-apps/views/connect-ios-appstore-modal.client.view.html',
			  controller: 'ConnectIosAppstoreModalController',
			  backdrop: true,
			  size: 'md',
			  resolve: {
				  ModalData: function() {
					  return {
						  mobileApp: $scope.mobileApp
					  };
				  }
			  }
		  });
		  modalInstance.result.then(
			  function(data) {
				  if (data.success === true) {
					  // Load the new data
					  $scope.fetchMobileApp(function(err, mobileApp) {
						  $scope.mobileApp = mobileApp;
					  });
				  }
			  }
		  );
	  };


	  /**
	   * Opens a modal which allows to connect to Google Android Playstore
	   */
	  $scope.connectAndroidStore = function() {
		  var modalInstance = $modal.open({
			  templateUrl: 'modules/mobile-apps/views/connect-android-appstore-modal.client.view.html',
			  controller: 'ConnectAndroidAppstoreModalController',
			  backdrop: true,
			  size: 'md',
			  resolve: {
				  ModalData: function() {
					  return {
						  mobileApp: $scope.mobileApp
					  };
				  }
			  }
		  });
		  modalInstance.result.then(
			  function(data) {
				  if (data.success === true) {
					  // Load the new data
					  EntryMain.loadMobileApp($scope.mobileApp._id, true, function(err, mobileApp) {
						  $scope.mobileApp = mobileApp;
					  });
				  }
			  }
		  );
	  };


	  /**
	   * Removes the collection from an Appstore
	   * @param storeType The store to disconnect from (ios/android)
       */
	  $scope.disconnectStore = function (storeType) {
		  var storeName = '';
		  if (storeType === 'ios') {
			  storeName = 'Apple Appstore';
		  } else if (storeType === 'android') {
			  storeName = 'Android Playstore';
		  } else {
			  // Should never happen but just to be sure
			  Utilities.showMessage(
				  'Error!',
				  'The store type is unknown. Please contact support!',
				  'error'
			  );
			  return;
		  }

		  SweetAlert.swal(
			  {
				  title             : 'Are you sure?',
				  text              : 'This will delete the connection to the ' + storeName + '.',
				  type              : 'warning',
				  showCancelButton  : true,
				  confirmButtonColor: '#DD6B55',
				  confirmButtonText : 'Yes, delete!',
				  cancelButtonText  : 'No, cancel!',
				  closeOnConfirm    : true,
				  closeOnCancel     : true
			  },
			  function (isConfirm) {
				  if (isConfirm) {

					  var sendData = {
						  mobileAppId: $scope.mobileApp._id,
						  storeType: storeType
					  };

					  AppstoreIntegration.disconnect(sendData).$promise
						  .then(
							  function(data) {
								  // Load the new data
								  EntryMain.loadMobileApp($scope.mobileApp._id, true, function(err, mobileApp) {
									  $scope.mobileApp = mobileApp;
								  });

								  Utilities.showMessage(
									  'Success!',
									  'The connection to ' + storeName + ' got removed!',
									  'success'
								  );
							  }
						  )
						  .catch(
							  function(error) {
								  Utilities.showMessageErrorResponse(error);
							  }
						  );

				  }
			  }
		  );
	  };


	  /**
	   * Opens a modal which allows to sync data to/from Appstore
	   */
	  $scope.appStoreConnector = function() {
		  var modalInstance = $modal.open({
			  templateUrl: 'modules/mobile-apps/views/appstore-connector-modal.client.view.html',
			  controller: 'AppstoreConnectorModalController',
			  backdrop: true,
			  size: 'md',
			  resolve: {
				  ModalData: function() {
					  return {
						  mobileApp: $scope.mobileApp
					  };
				  }
			  }
		  });
	  };


	  /**
	   * Opens a modal which allows the the creation of the xtm access token
	   */
	  $scope.generateXtmAccessToken = function() {
		  var modalInstance = $modal.open({
			  templateUrl: 'modules/mobile-apps/views/generate-xtm-access-token-modal.client.view.html',
			  controller: 'GenerateXtmAccessTokenModalController',
			  backdrop: true,
			  size: 'sm',
			  resolve: {
				  ModalData: function() {
					  return {
						  mobileApp: $scope.mobileApp,
						  xtmData: $scope.mobileApp._xtmCustomer
					  };
				  }
			  }
		  });
		  modalInstance.result.then(
			  function(data) {
				  if (data.tokenSet === true) {
					  $scope.mobileApp._xtmCustomer = data.xtmCustomer;
				  }
			  }
		  );
	  };

	  /**
	   * Delete the XTM integration of the current app
	   */
	  $scope.deleteXtmIntegration = function() {
		  SweetAlert.swal(
			  {
				  title             : 'Are you sure?',
				  text              : 'This will delete the XTM integration.',
				  type              : 'warning',
				  showCancelButton  : true,
				  confirmButtonColor: '#DD6B55',
				  confirmButtonText : 'Yes, delete!',
				  cancelButtonText  : 'No, cancel!',
				  closeOnConfirm    : true,
				  closeOnCancel     : true
			  },
			  function (isConfirm) {
				  if (isConfirm) {

					  var sendData = {
						  mobileAppId: $scope.mobileApp._id
					  };

					  XtmIntegration.deleteXtmCustomer(sendData).$promise
						  .then(
							  function(data) {
								  $scope.mobileApp._xtmCustomer = {};
								  Utilities.showMessage('Success', 'The XTM integration got deleted!', 'success');
							  }
						  )
						  .catch(
							  function(error) {
								  Utilities.showMessageErrorResponse(error);
							  }
						  );

				  }
			  }
		  );

	  };


	  /**
	 * Create a new order for the current app and go to the order page
	 */
	$scope.orderTranslation = function() {
		var sendData = {};
		sendData.mobileAppId = $scope.mobileAppId;

		TranslationOrder.translationOrderCreateFromApp(sendData,
		  function(response) {
			  $state.go('translationOrderView', {
				  mobileAppId: $scope.mobileAppId,
				  orderId: response.order._id
			  });
		  },
		  function(error) {
			  Utilities.showMessage(
				  'Error!',
				  error.toString(),
				  'error'
			  );
		  }
		);
	};

	/**
	 * Adds a new app
	 */
    $scope.addApp = function () {
		$state.go('createMobileApp');
    };

    $scope.editApp = function (mobileAppId, isTranslationMemory) {
      var newState = 'editMobileApp';
      if (isTranslationMemory) {
        newState = 'editTranslationMemory';
      }
      $state.go(newState, {mobileAppId: mobileAppId});
    };
    $scope.prepareRelease = function (mobileAppId) {
      $state.go('prepareRelease', {mobileAppId: mobileAppId});
    };

    $scope.changeEntry = function (appId) {
      $scope.loadedStatus = false;
      // $state.go('viewMobileApp', {
      //   mobileAppId: appId
      // });
      let url = `!/#/projects/${appId}`;
      location.href = url;
    };


    /**
     * Metadata handler
     */

    $scope.newMetadataFieldName = '';
    $scope.newMetadataFieldDescription = '';
    $scope.forbiddenKeys = ['description', 'comment', 'sketchId'];

    $scope.addNewMetadata = function () {
      if(!$scope.newMetadataFieldName)
        SweetAlert.swal({title: 'Metadata field name is required!', text: 'Please add a metadata field name before submitting.', type: 'warning'});
      else if($scope.mobileApp.metadata.some(function(item){ return item.fieldName === $scope.newMetadataFieldName; }))
        SweetAlert.swal({title: 'Entry already exists!', text: 'Please try a diffetent one.', type: 'warning'});
      else if($scope.forbiddenKeys.some(function(item){ return item.toLowerCase() === $scope.newMetadataFieldName.toLowerCase(); }))
        SweetAlert.swal({title: 'Field name not allowed!', text: 'Please try a diffetent one.', type: 'warning'});
      else if($scope.newMetadataFieldName)
      {
        var metadataId;
        if($scope.mobileApp.metadata.length){
          metadataId = $scope.mobileApp.metadata[$scope.mobileApp.metadata.length - 1].id + 1;
        } else {
          metadataId = 1;
        }
        
        $scope.mobileApp.metadata.push({
          id: metadataId, 
          fieldName: $scope.newMetadataFieldName, 
          description: $scope.newMetadataFieldDescription,
          order: metadataId
        });
      }
    };

    $scope.moveMetadata = function($event, id, direction) {
      $event.preventDefault();
			$event.stopPropagation();
      var index = $scope.mobileApp.metadata.findIndex(function(item){ return item.id === id; });
      if ($scope.mobileApp.metadata[index].order === 1 && direction === 'up' || $scope.mobileApp.metadata[index].order === $scope.mobileApp.metadata.length && direction === 'down')
        return false;
      
      var oldPos = $scope.mobileApp.metadata[index].order;
      var newPos;

      if(direction === 'up'){
        newPos = $scope.mobileApp.metadata[index].order - 1;
      } else{
        newPos = $scope.mobileApp.metadata[index].order + 1;
      }

      var newPosIndex = $scope.mobileApp.metadata.findIndex(function(item){ return item.order === newPos; });
      $scope.mobileApp.metadata[index].order = newPos; 
      $scope.mobileApp.metadata[newPosIndex].order = oldPos;
    };

    $scope.removeMetadata = function (id) {
      var index = $scope.mobileApp.metadata.findIndex(function(item){ return item.id === id; });
      SweetAlert.swal(
        {
				  title             : 'Are you sure?',
          text              : 'This will delete "' + $scope.mobileApp.metadata[index].fieldName + '" metadata field name.',
          type              : 'warning',
          showCancelButton  : true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText : 'Yes, delete it!',
          cancelButtonText  : 'No, cancel!',
          closeOnConfirm    : true,
          closeOnCancel     : true
			  },
			  function (isConfirm) {
          if (isConfirm) {
            $scope.mobileApp.metadata.splice(index, 1);
          }
			  });
    };

    $scope.openPDMapModal = function() {
      var modalInstance = $modal.open({
				templateUrl: 'modules/mobile-apps/views/connect-pd-modal.client.view.html',
				controller: 'PdConfigurationModalController',
				backdrop: true,
				size: 'md',
				resolve: {
					ModalData: function() {
						return {
							mobileApp: $scope.mobileApp
						};
					}
				}
			}).result.catch(function(error) {
				if (!(error === 'cancel' || error === 'escape key press' || error === undefined)) {
					throw error;
				}
			});
    };

	$scope.hasJiraConfig = false;
	$scope.jiraConfig = {};

    $scope.openJiraConfigModal = function() {
      var modalInstance = $modal.open({
				templateUrl: 'modules/mobile-apps/views/connect-jira-modal.client.view.html',
				controller: 'JiraConfigurationModalController',
				backdrop: true,
				size: 'md',
				resolve: {
					ModalData: function() {
						return {
							mobileApp: $scope.mobileApp,
							jiraConfig: $scope.jiraConfig
						};
					}
				}
			}).result.catch(function(error) {
				if (!(error === 'cancel' || error === 'escape key press' || error === undefined)) {
					throw error;
				}
			});
    };

    $scope.checkJiraConfig = function() {
        JiraApi.getConfiguration({ mobileAppId: $scope.mobileAppId }).$promise
            .then(
                function (jiraConfig) {
                    if(jiraConfig.missingJiraConfig === false) {
                        $scope.jiraConfig = jiraConfig;
                        $scope.hasJiraConfig = true;
                    }
                }
            )
            .catch(
                function (err) {
                    console.log(err);
                }
            );
    };
    $scope.checkJiraConfig();

    $rootScope.$on('addedJiraConfig', function() {
      $scope.checkJiraConfig();
    });


    /**
     * Tag categories handler
     */
    $scope.newTagCategoryName = '';
    $scope.newTagCategoryColor = '#000000';
    $scope.newTagCategoryIcon = 'fas fa-heart';
    $scope.newTagCategories = [];
    $scope.removingTagCategories = [];

    $scope.isDefaultCategory = function(tagCategoryName){
      if(tagCategoryName){
        return DEFAULT_TAG_CATEGORIES.some(function(tag){ return tag.name.toLowerCase() === tagCategoryName.toLowerCase(); });
      }
      return;
    };

    $scope.moreThanDefaultCategories = function(){
      return $scope.tagCategories.length > DEFAULT_TAG_CATEGORIES.length;
    };

    $scope.addNewTagCategory = function () {
      var arrayUnique = function (array) {
        var a = array.concat();
        for (var i = 0; i < a.length; ++i) {
          for (var j = i + 1; j < a.length; ++j) {
            if (a[i] === a[j])
              a.splice(j--, 1);
          }
        }
        return a;
      };

      if (!$scope.newTagCategoryName) {
        SweetAlert.swal({ title: 'Category name field name is required!', text: 'Please add a tagCategory field name before submitting.', type: 'warning' });
      }
      else if ($scope.tagCategories.some(function (item) { return item.name.toLowerCase() === $scope.newTagCategoryName.toLowerCase(); })) {
        SweetAlert.swal({ title: 'Category already exists!', text: 'Please try a diffetent one.', type: 'warning' });
      }
      else {
        if (!$scope.newTagCategoryColor) {
          $scope.newTagCategoryColor = '#000000';
        }

        if (!$scope.newTagCategoryIcon) {
          $scope.newTagCategoryIcon = 'fas fa-heart';
          $('.iconpicker-container i').attr('class', $scope.newTagCategoryIcon);
        }

        var iconUnicode;
        $('.iconpicker-container i').each(function () {
          iconUnicode = '&#x' + window.getComputedStyle(this, ':before').content
            .replace(/'|"/g, '') // <-----
            .charCodeAt(0)
            .toString(16);
        });

        $scope.newTagCategories.push({
          name: $scope.newTagCategoryName,
          color: $scope.newTagCategoryColor,
          icon: iconUnicode,
          mobileApp: $scope.mobileAppId
        });

        // Checking if there's already a removing tag category with same props,
        // so that is not going to be removed when saving settings
        var removingIndex = $scope.removingTagCategories.findIndex(function (item) {
          return item.name === $scope.newTagCategoryName &&
            item.color === $scope.newTagCategoryColor &&
            item.icon === iconUnicode &&
            item.mobileApp === $scope.mobileAppId;
        });
        if (removingIndex !== -1) {
          $scope.removingTagCategories.splice(removingIndex, 1);
        }

        $scope.tagCategories = arrayUnique($scope.tagCategories.concat($scope.newTagCategories));
      }
    };

    $scope.removeTagCategory = function (tagCategoryName) {
      var index = $scope.tagCategories.findIndex(function(item){ return item.name === tagCategoryName; });
      SweetAlert.swal(
        {
				  title             : 'Are you sure?',
          text              : 'This will delete "' + $scope.tagCategories[index].name + '" Tag Category.',
          type              : 'warning',
          showCancelButton  : true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText : 'Yes, delete it!',
          cancelButtonText  : 'No, cancel!',
          closeOnConfirm    : true,
          closeOnCancel     : true
			  },
			  function (isConfirm) {
          if (isConfirm) {
            var category = $scope.tagCategories[index];
            $scope.tagCategories.splice(index, 1);
           
            index = $scope.newTagCategories.findIndex(function(item){ return item.name === tagCategoryName; });
            if(index !== -1){
              $scope.newTagCategories.splice(index, 1);
            } else {
              $scope.removingTagCategories.push(category);
            }
          }
			  });
    };

    $scope.updateSelectedColorFromPalette = function(){
      $scope.newTagCategoryColor = $('.color-picker').val();
    };

    $scope.triggerColorPicker = function(){
      $('#inputColorPicker').click();
    };

    $scope.updateSelectedIcon = function(){
      $('.iconpicker-container i').attr('class', $scope.newTagCategoryIcon);
	};

	$scope.addIpRange = function(ipRange){
		if($scope.mobileApp.apiAccessIPRange.filter(function(ip) { return ip.ip === ipRange; }).length ===0 ){
			$scope.mobileApp.apiAccessIPRange.push({ip: ipRange});
		}
	};

    if($('#selectCategoryIcon').length){
      $('#selectCategoryIcon').iconpicker({defaultValue: 'fas fa-heart'});
    }
  }
]);
